<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild fixed-bottom navbar-fixed-top">
    <!-- 电脑导航 -->
    <div class="container-fuild white-bg">
        <div class="header-nav container hidden-xs header-nav-pc">
        <!-- 导航logo -->
            <div class="header-nav-logo">
                <img src="@/assets/image/logo.png">
                <span class="hidden-sm">延安新材料产业园</span>
                
            </div>
            <!-- 导航内容 -->
            <ul class="header-nav-wrapper">
                <li
                v-for="(item,index) in navList"
                :key="index"
                :class="index==navIndex?'active':''"
                @click="navClick(index,item.name)"
                >
                <router-link :to="item.path">
                    {{item.name}}
                    <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
                    <i class="underline"></i>
                </router-link>
                <dl v-if="item.children.length>0">
                    <dt v-for="(i,n) in item.children" :key="n">
                    <router-link :to="i.path">{{i.name}}</router-link>
                    </dt>
                </dl>
                </li>
            </ul>
        </div>
    </div>

    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <img class="logo-pic" src="@/assets/image/logo.png" alt="logo">
        <span>延安新材料产业园</span>
        <span @click="showDrawer" :class="menuClass"></span>

        <el-drawer
            size="80%"
            :with-header="false"
            custom-class="menu-drawer"
            :visible.sync="drawer"
            :modal-append-to-body="false"
        >
            <div class="dra-header">
                <i @click="hiddeDrawer" class="el-icon-close"></i>
            </div>

            <ul class="header-m-nav-wrapper">
                <li
                    v-for="(item,index) in navList"
                    :key="index"
                    :class="index==navIndex?'active':''"
                >
                    <div class="h-m-n-link" v-if="item.children.length>0" @click="switchFild(item.name)" :class="{active: selectedName === item.name}">
                        <a>
                            {{item.name}}
                        </a>
                        <span class="glyphicon glyphicon-menu-down"></span>
                    </div>
                    <div @click="navClick(index,item.name)" class="h-m-n-link" v-else>
                        <router-link :to="item.path">
                            {{item.name}}
                        </router-link>
                    </div>
                    
                    <div class="sub-m-con" v-if="item.children.length>0">
                        <div  class="sub-m-con-item" v-for="(i,n) in item.children" :key="n"  @click="navClick(index,i.name)">
                            <router-link :to="i.path">{{i.name}}</router-link>
                        </div>
                    </div>
                </li>
            </ul>

        </el-drawer>

        
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
        selectedName: '',
        drawer: false,
      navIndex: 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-hamburger",
      navList: [
        {
          name: "首页",
          path: "/home",
          children: []
        },
        {
          name: "走进园区",
          path: "/park",
          children: [
            {
                name: "园区概况",
                path: "/park/park-detail/7",
            },
            {
              name: "大事记",
              path: "/park/big-event"
            },
            {
              name: "园区荣誉",
              path: "/park/honor-wall"
            },
            {
                name: "园区规划",
                path: "/park/park-detail/8",
            },
            {
                name: "组织架构",
                path: "/park/orgnization",
            },
            {
              name: "关于我们",
              path: "/park/about"
            }
          ]
        },
        {
          name: "资讯动态",
          path: "/news",
          children: [
            {
                name: "园区公告",
                path: "/news/news-list/0",
            },
            {
                name: "园区动态",
                path: "/news/news-list/1",
            },
            {
                name: "产业信息",
                path: "/news/news-list/2",
            },
          ]
        },
        {
          name: "园区服务",
          path: "/service",
          children: [
            {
                name: "交通畅达",
                path: "/service/service-detail/0",
            },
            {
                name: "资源支持",
                path: "/service/service-detail/1",
            },
            {
                name: "服务贴心",
                path: "/service/service-detail/2",
            },
            {
                name: "设施完善",
                path: "/service/service-detail/4",
            },
            // {
            //     name: "政策优厚",
            //     path: "/service/service-detail/9",
            // },
            {
                name: "政企服务",
                path: "/service/policy",
            },
            // {
            //     name: "综合交通",
            //     path: "/service/service-detail/0",
            // },
            // {
            //     name: "人力资源",
            //     path: "/service/service-detail/1",
            // },
            // {
            //     name: "城市产业",
            //     path: "/service/service-detail/2",
            // },
            // {
            //     name: "政企服务",
            //     path: "/service/policy",
            // },
            // {
            //     name: "配套设施",
            //     path: "/service/service-detail/4",
            // }
          ]
        },
        {
          name: "招商项目",
          path: "/project",
          children: []
        },
        {
          name: "企业风采",
          path: "/enterprise",
          children: []
        },
        {
          name: "企业入驻",
          path: "/enter-process",
          children: [
            {
                name: "入驻流程",
                path: "/enter-process/settlement/5",
            },
            {
                name: "优惠政策",
                path: "/enter-process/settlement/6",
            }
          ]
        },
        {
            name: "联系我们",
            path: "/contactus",
            children: []
        }
      ]
    };
  },
  methods: {
    switchFild (name) {
        if (this.selectedName === name) {
            this.selectedName = ''
        } else {
            this.selectedName = name;
        }
        
    },
    showDrawer () {
        this.drawer = true;
    },
    hiddeDrawer () {
        this.drawer = false;
    },
    navClick(index, name) {
    this.drawer = false;
      this.navIndex = index;
      this.menuName = name;
      
    },
    
  }
};
</script>
<style scoped lang="scss">
@import "~@/assets/css/mixin.scss";
.header-nav-pc {
    &:after,&::before {
        display: none;
    }
    @include flex(space-between, center);
    flex-wrap: nowrap;
}
.header-m-nav-wrapper {
    text-align: left;
    padding-top: 20px;
    .sub-m-con {
        .sub-m-con-item {
            padding: 0 20px;
            @include flex(space-between, center);
            height: 44px;
            background: #FFFFFF;
            border-bottom: 1px solid #EEEEEE;
        }
        a {
            font-size: 12px;
            font-weight: bold;
            color: #666;
            text-decoration: none;
            &.router-link-active {
                color: #0075EA;
            }
        }
    }
    .h-m-n-link {
        height: 60px;
        background: #FFFFFF;
        border-bottom: 1px solid #EEEEEE;
        padding: 0 20px;
        @include flex(space-between, center);

        a {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            text-decoration: none;
            &.router-link-active {
                color: #0075EA;
            }
        }
        .glyphicon {
            color: #8c8c8c;
            transition: all ease 0.6s;
        }

        &.active {
            .glyphicon {
                transform: rotate(180deg);
            }
        }
    }
}
.sub-m-con {
    display: none;
}
.h-m-n-link {
    &.active+.sub-m-con {
        display: block;
    }
}
.dra-header {
    color: #333;
    font-size: 20px;
    text-align: left;
    height: 24px;
    line-height: 24px;
    padding: 10px 20px;
    font-weight: 700;
    i {
        font-weight: 700;
    }
}
.white-bg {
    background: #fff;
}
.logo-pic {
    width: 25px;
    height: 25px;
}
/* 顶部 */
#header {
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 80px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  height: 100%;
  float: left;
  position: relative;
  display: flex;
    align-items: center;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 52px;
  height: 52px;
  margin-right: 20px;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 80px;
  float: right;
  margin: 0;
  max-width: 800px;
  @include flex(flex-end, center);
  flex-wrap: nowrap;
  white-space: nowrap;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #666;
  font-size: 15px;
  font-weight: bold;
  display: inline-block;
  position: relative;
  
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  width: 0;
  height: 4px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #0075e9;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
#header .header-nav .header-nav-wrapper > li > dl a {
    &.router-link-active {
        color: #1e73be;
        text-decoration: none;
    }
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li > a.router-link-active {
  color: #0075e9;
  text-decoration: none;
//   border-top: 4px solid #0075e9;
    .underline {
        opacity: 1;
        width: 100%;
        left: 0;
    }
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80px;
  left: 0;
  z-index: 999999;
  background: rgba($color: #F9F9F9, $alpha: 0.95);
  padding: 20px;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
    width: 100%;
    height: 35px;
    font-size: 14px;
    color: #666;
    line-height: 35px;
    letter-spacing: 1px;
    a {
        color: #666;
        text-decoration: none;
    }
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
// #header .header-nav .header-nav-wrapper > li:hover {
//     background: rgba($color: #F9F9F9, $alpha: 0.95);
// }
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
    cursor: pointer;
    a {
        color: #0075EA;
    }
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    background: rgba(34, 62, 85, 0.9);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: relative;
    color: #fff;
    z-index: 999999;
    font-size: 18px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    background: rgba(34, 62, 85, 0.8);
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid rgba(34, 62, 85, 0.9);
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue